import { ForecastEffects } from './forecast.effects';

export const effects: any[] = [ForecastEffects];

export * from './forecast.effects';
